import API from './Api'

const endpointBaseUrl = 'register';

class RegisterService {
    baseUrl(){
        return endpointBaseUrl;
    }

    registerUser(userData) {
        return API.post(endpointBaseUrl, 
            { "email": userData.email, 
              "password": userData.password, 
              "firstName": userData.firstName, 
              "lastName": userData.lastName,
              "phone": userData.phone });
    }
}

export default new RegisterService();